import React from 'react';
import './Portfolio.css';
import project1 from '../../assets/projet_ecommerce.PNG';
import project2 from '../../assets/projet_social.PNG';
import project3 from '../../assets/projet_maquette.PNG';
import project4 from '../../assets/projet_actu.PNG';


const Portfolio = () => {
  const portfolioItems = [
    {
      title: "Site E-commerce",
      category: "Développement Web",
      image: project1,
      tags: ["HTML", "CSS", "JS", "DJANGO", "SQLite"]
    },
    {
      title: "Plateforme Social",
      category: "Solution Application Web",
      image: project2,
      tags: ["HTML", "CSS", "JS", "DJANGO", "SQLite"]
    },
    {
      title: "Application Mobile",
      category: "Développement Mobile",
      image: project3,
      tags: ["Flutter", "Firebase"]
    },
    {
      title: "Site Magazine",
      category: "Design & Développement",
      image: project4,
      tags: ["WordPress", "SEO", "UI/UX"]
    }
  ];

  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <h2 className="section-title">Nos Réalisations</h2>
        <p className="section-subtitle">Découvrez nos réalisations récentes</p>

        <div className="portfolio-grid">
          {portfolioItems.map((item, index) => (
            <div key={index} className="portfolio-item">
              <div className="portfolio-image">
                <img src={item.image} alt={item.title} />
                <div className="portfolio-overlay">
                  <div className="overlay-content">
                    <h3>{item.title}</h3>
                    <p>{item.category}</p>
                    <div className="portfolio-tags">
                      {item.tags.map((tag, i) => (
                        <span key={i}>{tag}</span>
                      ))}
                    </div>
                    <a href="#" className="btn-outline">Voir le projet</a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <a href="#contact" className="btn">Voir tous nos projets</a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;